
<template>
  <v-card>
    <v-toolbar color="primary" dark>
      <v-tooltip bottom>
        <v-btn flat icon @click="$router.go(-1)" slot="activator">
          <v-icon>far fa-arrow-left</v-icon>
        </v-btn>
        <span>Back</span>
      </v-tooltip>
      <v-toolbar-title>Marking Guide</v-toolbar-title>
      <v-spacer />
      <v-btn
        @click.stop="save"
        flat
        icon
        :loading="isCreatePending"
        :disabled="text.trim() === (current || { text: '' }).text.trim()"
        v-shortkey="['ctrl', 's']" @shortkey="save()"
      >
        <v-icon>fal fa-save</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
        <editor
          v-model="text"
          :options="opts"
          previewStyle="vertical"
          height="100%"
        />
      </v-card-text>
  </v-card>
</template>
<script>
/* eslint-disable import/no-extraneous-dependencies */
import 'tui-editor/dist/tui-editor.css';
import 'tui-chart/dist/tui-chart.min.css';
import 'tui-color-picker/dist/tui-color-picker.min.css';
// import 'tui-editor/dist/tui-editor-contents.css';
import 'codemirror/lib/codemirror.css';
import { Editor } from '@toast-ui/vue-editor';
import 'tui-color-picker';
import 'raphael';
import 'tui-chart';
import 'tui-editor/dist/tui-editor-extScrollSync';
import 'tui-editor/dist/tui-editor-extTable';
import 'tui-editor/dist/tui-editor-extUML';
import 'tui-editor/dist/tui-editor-extColorSyntax';
import 'tui-editor/dist/tui-editor-extChart';
import { mapGetters, mapState, mapMutations } from 'vuex';

const chart = {
  name: 'chart',
  minWidth: 100,
  maxWidth: 600,
  minHeight: 100,
  maxHeight: 300,
};

export default {
  components: {
    editor: Editor,
  },
  data() {
    return {
      text: '',
      opts: {
        usageStatistics: false,
        previewStyle: 'vertical',
        exts: ['scrollSync', 'colorSyntax', 'uml', chart, 'table'],
      },
    };
  },
  computed: {
    ...mapGetters('heuristics', ['current']),
    ...mapState('heuristics', ['isCreatePending']),
    copy() {
      return (this.current && this.current.clone()) || new this.$FeathersVuex.Heuristic();
    },
  },
  methods: {
    ...mapMutations('heuristics', ['setCurrent']),
    async save() {
      if (this.copy.text === (this.current || {}).text) return;
      delete this.copy._id;
      const res = await this.copy.save();
      this.setCurrent(res._id);
    },
  },
  mounted() {
    this.text = this.copy.text;
  },
  updated() {
    this.text = this.copy.text;
  },
  watch: {
    text() {
      if (this.text !== this.copy.text) this.copy.text = this.text;
    },
  },
};
</script>

<style scoped>
.v-card__text {
  padding: 0!important;
  height: calc(100vh - 64px)
}
</style>
